import { Illustration } from 'foundations-components/transitional/components/Illustration';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PAYMENTS_UNDERWRITING_SUPPORT_SLACK = 'https://hubspot.slack.com/archives/C02N4A8930V';
function PaymentEscalation() {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "1000",
    as: "div",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      flexDirection: "row",
      justifyContent: "center",
      flexWrap: "wrap",
      children: [/*#__PURE__*/_jsx(Illustration, {
        "data-test-id": "payment-illustration",
        name: "payments-button",
        width: "33%"
      }), /*#__PURE__*/_jsx(View, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          "data-test-id": "payment-escalation-body",
          message: "app.escalations.payment.description_jsx",
          elements: {
            UILink: Link
          },
          options: {
            href: PAYMENTS_UNDERWRITING_SUPPORT_SLACK,
            external: true
          }
        })
      })]
    })
  });
}
export default PaymentEscalation;